import React from "react";
import { Container, Row, Col } from "@ui/wrapper";
import Button from "@ui/button";
import { ErrorWrap } from "./style";

const ErroArea = () => {
    return (
        <ErrorWrap>
            <Container>
                <Row>
                    <Col xl={7} lg={8} mx="auto">
                        <h1>404</h1>
                        <h2>MMH! DIE SEITE EXISTIERT NICHT</h2>
                        <p>Es tut uns leid, die Seite wurde nicht gefunden.</p>
                        <Button path="/">Zur&uuml;ck zur Startseite</Button>
                    </Col>
                </Row>
            </Container>
        </ErrorWrap>
    );
};

export default ErroArea;
